import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // for using ngModel directive
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { HisSharedModule } from 'hisng';
import { FileUploadModule } from 'primeng/fileupload';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { ROUTE_CONFIG } from './businesstripapplication.routes';
import { BusinesstripApplicationFormComponent } from './component/businesstripapplication-form.component';
import { BusinesstripApplicationSearchComponent } from './component/businesstripapplication-search.component';
import { TabViewModule } from 'primeng/tabview';
import { RadioButtonModule } from 'primeng/radiobutton';
import { BusinesstripApplicationSearchResultComponent } from './component/businesstripapplication-search-result.component';
import { BusinesstripApplicationOverviewComponent } from './component/businesstripapplication-overview.component';
import { BusinesstripApplicationViewsSharedModule } from './component/views/businesstripapplication-views-shared.module';
import { CommonSharedModule } from '../../common/common-shared.module';
import { ErpWorkflowCoreModule } from '../../common/workflow/erpworkflow-core.module';

/**
 * SharedModule for BusinesstripApplication.
 */
@NgModule( {
    declarations: [
        BusinesstripApplicationFormComponent,
        BusinesstripApplicationOverviewComponent,
        BusinesstripApplicationSearchComponent,
        BusinesstripApplicationSearchResultComponent,
    ],
    exports: [],
    imports: [
        // Angular
        AutoCompleteModule,
        CommonModule,
        FormsModule,
        PanelModule,
        ReactiveFormsModule,
        RouterModule.forRoot( ROUTE_CONFIG, { onSameUrlNavigation: 'reload' } ),
        // PrimeNG
        DialogModule,
        CalendarModule,
        TableModule,
        FileUploadModule,
        PaginatorModule,
        OverlayPanelModule,
        TabViewModule,
        RadioButtonModule,
        // HIS
        HisSharedModule,
        // Common
        CommonSharedModule,
        ErpWorkflowCoreModule,
        // Views
        BusinesstripApplicationViewsSharedModule,
        ErpWorkflowCoreModule,
    ]
} )
export class BusinesstripApplicationManagementSharedModule {
}
